import { render, staticRenderFns } from "./SelectionListItem.vue?vue&type=template&id=1152bec6&"
import script from "./SelectionListItem.vue?vue&type=script&lang=js&"
export * from "./SelectionListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCheckbox,VListItem,VListItemAction,VListItemContent,VListItemGroup,VListItemTitle})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1152bec6')) {
      api.createRecord('1152bec6', component.options)
    } else {
      api.reload('1152bec6', component.options)
    }
    module.hot.accept("./SelectionListItem.vue?vue&type=template&id=1152bec6&", function () {
      api.rerender('1152bec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/SelectionListItem.vue"
export default component.exports